// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Theme-aware overrides for Jira items + workspace select modal (sc-4) */

/* ─── Jira items ─── */
.jira-items-overlay {
  position: relative !important;
  top: auto !important;
  left: auto !important;
  right: auto !important;
  bottom: auto !important;
  z-index: auto !important;
  background-color: var(--bg-primary) !important;
  color: var(--text-primary);
  min-height: 0;
  flex: 1 1;
}

.jira-items-container {
  background-color: var(--bg-primary) !important;
  color: var(--text-primary);
}

.jira-items-container .back-btn {
  background: var(--surface) !important;
  color: var(--text-primary) !important;
  border: 1px solid var(--border) !important;
}

.jira-items-tabs {
  background: var(--surface) !important;
  border-color: var(--border) !important;
}

.jira-items-tabs .tab-btn {
  color: var(--text-secondary) !important;
  background: transparent !important;
}

.jira-items-tabs .tab-btn.active {
  color: var(--primary, #3b82f6) !important;
  border-bottom-color: var(--primary, #3b82f6) !important;
}

.jira-items-content {
  background: var(--bg-primary) !important;
  color: var(--text-primary) !important;
}

.jira-items-content .empty-state,
.jira-items-container .empty-state {
  background: var(--surface) !important;
  color: var(--text-primary) !important;
  border: 1px dashed var(--border) !important;
}

.jira-items-content .empty-state h3,
.jira-items-content .empty-state p {
  color: var(--text-secondary) !important;
}

/* ─── All workspaces + select project modal ─── */
.all-workspaces-container {
  color: var(--text-primary);
}

.all-workspaces-container .workspace-search input,
.workspaces-table,
.workspace-row,
.workspaces-list {
  background: var(--surface) !important;
  color: var(--text-primary) !important;
  border-color: var(--border) !important;
}

.workspace-modal {
  background: var(--surface) !important;
  color: var(--text-primary) !important;
  border: 1px solid var(--border);
}

.workspace-modal .modal-header {
  background: var(--primary, #2563eb) !important;
}

.workspace-modal .modal-body {
  background: var(--surface) !important;
  color: var(--text-primary) !important;
}

.workspace-modal .form-input {
  background: var(--input-background, var(--surface)) !important;
  color: var(--text-primary) !important;
  border-color: var(--input-border, var(--border)) !important;
}

.workspace-modal .modal-footer {
  background: var(--bg-tertiary, var(--surface-hover)) !important;
  border-color: var(--border) !important;
}

.workspace-modal .btn-outline {
  background: transparent !important;
  color: var(--text-primary) !important;
  border-color: var(--border) !important;
}

.workspace-modal.project-select-modal .project-select-item {
  background: var(--surface) !important;
  color: var(--text-primary) !important;
  border-color: var(--border) !important;
}

.workspace-modal.project-select-modal .project-select-item:hover {
  background: var(--surface-hover) !important;
}

.workspace-modal.project-select-modal .project-select-item-name {
  color: var(--text-primary) !important;
}

.workspace-modal.project-select-modal .project-select-item-meta {
  color: var(--text-secondary) !important;
}

.workspace-modal.project-select-modal .project-select-empty,
.workspace-modal .empty-state,
.project-select-empty {
  background: var(--bg-tertiary, var(--surface-hover)) !important;
  color: var(--text-primary) !important;
  border: 1px dashed var(--border) !important;
  border-radius: 8px;
}

.workspace-modal.project-select-modal .project-select-empty h3,
.workspace-modal.project-select-modal .project-select-empty p,
.project-select-empty h3,
.project-select-empty p {
  color: var(--text-secondary) !important;
}

.workspace-modal.project-select-modal .project-select-subtitle {
  color: rgba(255, 255, 255, 0.85) !important;
}

/* Projects status tabs — app uses data-theme, not .dark-mode */
[data-theme="dark"] .status-tabs {
  background-color: var(--surface) !important;
  border-color: var(--border) !important;
}

[data-theme="dark"] .status-tab {
  background-color: transparent !important;
  color: var(--text-secondary) !important;
  border: 1px solid transparent !important;
}

[data-theme="dark"] .status-tab:hover {
  background-color: var(--surface-hover) !important;
  color: var(--text-primary) !important;
}

[data-theme="dark"] .status-tab.active {
  background-color: color-mix(in srgb, var(--primary, #3b82f6) 18%, var(--surface)) !important;
  color: var(--text-primary) !important;
  border-color: var(--primary, #3b82f6) !important;
  box-shadow: none !important;
}

[data-theme="dark"] .status-tab.active .tab-count {
  background-color: color-mix(in srgb, var(--primary, #3b82f6) 30%, transparent) !important;
}

[data-theme="dark"] .projects-container,
[data-theme="dark"] .projects-table-container,
[data-theme="dark"] .projects-table {
  background: var(--bg-primary) !important;
  color: var(--text-primary) !important;
  border-color: var(--border) !important;
}

[data-theme="dark"] .projects-table th {
  background: var(--table-header, var(--bg-tertiary)) !important;
  color: var(--text-secondary) !important;
  border-color: var(--border) !important;
}

[data-theme="dark"] .projects-table td {
  border-color: var(--border) !important;
  color: var(--text-primary) !important;
}

/* Projects workspace embed */
.rt-projects-embed .projects-container {
  padding: 0 !important;
  background: transparent !important;
  box-shadow: none !important;
}

.rt-projects-search {
  width: 100%;
  max-width: 28rem;
  padding: 0.55rem 2.25rem 0.55rem 2.4rem;
  border: 1px solid var(--border);
  border-radius: 8px;
  background: var(--input-background, var(--surface));
  color: var(--text-primary);
  font: inherit;
}

.rt-projects-search:focus {
  outline: none;
  border-color: var(--primary, #2563eb);
  box-shadow: 0 0 0 3px color-mix(in srgb, var(--primary, #2563eb) 20%, transparent);
}

.rt-projects-embedded .projects-header {
  margin-bottom: 12px;
  align-items: flex-end;
}
`, "",{"version":3,"sources":["webpack://./src/styles/rt2-sc4-theme.css"],"names":[],"mappings":"AAAA,yEAAyE;;AAEzE,uBAAuB;AACvB;EACE,6BAA6B;EAC7B,oBAAoB;EACpB,qBAAqB;EACrB,sBAAsB;EACtB,uBAAuB;EACvB,wBAAwB;EACxB,8CAA8C;EAC9C,0BAA0B;EAC1B,aAAa;EACb,SAAO;AACT;;AAEA;EACE,8CAA8C;EAC9C,0BAA0B;AAC5B;;AAEA;EACE,qCAAqC;EACrC,qCAAqC;EACrC,0CAA0C;AAC5C;;AAEA;EACE,qCAAqC;EACrC,sCAAsC;AACxC;;AAEA;EACE,uCAAuC;EACvC,kCAAkC;AACpC;;AAEA;EACE,yCAAyC;EACzC,uDAAuD;AACzD;;AAEA;EACE,wCAAwC;EACxC,qCAAqC;AACvC;;AAEA;;EAEE,qCAAqC;EACrC,qCAAqC;EACrC,2CAA2C;AAC7C;;AAEA;;EAEE,uCAAuC;AACzC;;AAEA,kDAAkD;AAClD;EACE,0BAA0B;AAC5B;;AAEA;;;;EAIE,qCAAqC;EACrC,qCAAqC;EACrC,sCAAsC;AACxC;;AAEA;EACE,qCAAqC;EACrC,qCAAqC;EACrC,+BAA+B;AACjC;;AAEA;EACE,8CAA8C;AAChD;;AAEA;EACE,qCAAqC;EACrC,qCAAqC;AACvC;;AAEA;EACE,8DAA8D;EAC9D,qCAAqC;EACrC,2DAA2D;AAC7D;;AAEA;EACE,+DAA+D;EAC/D,sCAAsC;AACxC;;AAEA;EACE,kCAAkC;EAClC,qCAAqC;EACrC,sCAAsC;AACxC;;AAEA;EACE,qCAAqC;EACrC,qCAAqC;EACrC,sCAAsC;AACxC;;AAEA;EACE,2CAA2C;AAC7C;;AAEA;EACE,qCAAqC;AACvC;;AAEA;EACE,uCAAuC;AACzC;;AAEA;;;EAGE,+DAA+D;EAC/D,qCAAqC;EACrC,2CAA2C;EAC3C,kBAAkB;AACpB;;AAEA;;;;EAIE,uCAAuC;AACzC;;AAEA;EACE,2CAA2C;AAC7C;;AAEA,+DAA+D;AAC/D;EACE,2CAA2C;EAC3C,sCAAsC;AACxC;;AAEA;EACE,wCAAwC;EACxC,uCAAuC;EACvC,wCAAwC;AAC1C;;AAEA;EACE,iDAAiD;EACjD,qCAAqC;AACvC;;AAEA;EACE,4FAA4F;EAC5F,qCAAqC;EACrC,gDAAgD;EAChD,2BAA2B;AAC7B;;AAEA;EACE,yFAAyF;AAC3F;;AAEA;;;EAGE,wCAAwC;EACxC,qCAAqC;EACrC,sCAAsC;AACxC;;AAEA;EACE,8DAA8D;EAC9D,uCAAuC;EACvC,sCAAsC;AACxC;;AAEA;EACE,sCAAsC;EACtC,qCAAqC;AACvC;;AAEA,6BAA6B;AAC7B;EACE,qBAAqB;EACrB,kCAAkC;EAClC,2BAA2B;AAC7B;;AAEA;EACE,WAAW;EACX,gBAAgB;EAChB,uCAAuC;EACvC,+BAA+B;EAC/B,kBAAkB;EAClB,mDAAmD;EACnD,0BAA0B;EAC1B,aAAa;AACf;;AAEA;EACE,aAAa;EACb,qCAAqC;EACrC,kFAAkF;AACpF;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;AACvB","sourcesContent":["/* Theme-aware overrides for Jira items + workspace select modal (sc-4) */\n\n/* ─── Jira items ─── */\n.jira-items-overlay {\n  position: relative !important;\n  top: auto !important;\n  left: auto !important;\n  right: auto !important;\n  bottom: auto !important;\n  z-index: auto !important;\n  background-color: var(--bg-primary) !important;\n  color: var(--text-primary);\n  min-height: 0;\n  flex: 1;\n}\n\n.jira-items-container {\n  background-color: var(--bg-primary) !important;\n  color: var(--text-primary);\n}\n\n.jira-items-container .back-btn {\n  background: var(--surface) !important;\n  color: var(--text-primary) !important;\n  border: 1px solid var(--border) !important;\n}\n\n.jira-items-tabs {\n  background: var(--surface) !important;\n  border-color: var(--border) !important;\n}\n\n.jira-items-tabs .tab-btn {\n  color: var(--text-secondary) !important;\n  background: transparent !important;\n}\n\n.jira-items-tabs .tab-btn.active {\n  color: var(--primary, #3b82f6) !important;\n  border-bottom-color: var(--primary, #3b82f6) !important;\n}\n\n.jira-items-content {\n  background: var(--bg-primary) !important;\n  color: var(--text-primary) !important;\n}\n\n.jira-items-content .empty-state,\n.jira-items-container .empty-state {\n  background: var(--surface) !important;\n  color: var(--text-primary) !important;\n  border: 1px dashed var(--border) !important;\n}\n\n.jira-items-content .empty-state h3,\n.jira-items-content .empty-state p {\n  color: var(--text-secondary) !important;\n}\n\n/* ─── All workspaces + select project modal ─── */\n.all-workspaces-container {\n  color: var(--text-primary);\n}\n\n.all-workspaces-container .workspace-search input,\n.workspaces-table,\n.workspace-row,\n.workspaces-list {\n  background: var(--surface) !important;\n  color: var(--text-primary) !important;\n  border-color: var(--border) !important;\n}\n\n.workspace-modal {\n  background: var(--surface) !important;\n  color: var(--text-primary) !important;\n  border: 1px solid var(--border);\n}\n\n.workspace-modal .modal-header {\n  background: var(--primary, #2563eb) !important;\n}\n\n.workspace-modal .modal-body {\n  background: var(--surface) !important;\n  color: var(--text-primary) !important;\n}\n\n.workspace-modal .form-input {\n  background: var(--input-background, var(--surface)) !important;\n  color: var(--text-primary) !important;\n  border-color: var(--input-border, var(--border)) !important;\n}\n\n.workspace-modal .modal-footer {\n  background: var(--bg-tertiary, var(--surface-hover)) !important;\n  border-color: var(--border) !important;\n}\n\n.workspace-modal .btn-outline {\n  background: transparent !important;\n  color: var(--text-primary) !important;\n  border-color: var(--border) !important;\n}\n\n.workspace-modal.project-select-modal .project-select-item {\n  background: var(--surface) !important;\n  color: var(--text-primary) !important;\n  border-color: var(--border) !important;\n}\n\n.workspace-modal.project-select-modal .project-select-item:hover {\n  background: var(--surface-hover) !important;\n}\n\n.workspace-modal.project-select-modal .project-select-item-name {\n  color: var(--text-primary) !important;\n}\n\n.workspace-modal.project-select-modal .project-select-item-meta {\n  color: var(--text-secondary) !important;\n}\n\n.workspace-modal.project-select-modal .project-select-empty,\n.workspace-modal .empty-state,\n.project-select-empty {\n  background: var(--bg-tertiary, var(--surface-hover)) !important;\n  color: var(--text-primary) !important;\n  border: 1px dashed var(--border) !important;\n  border-radius: 8px;\n}\n\n.workspace-modal.project-select-modal .project-select-empty h3,\n.workspace-modal.project-select-modal .project-select-empty p,\n.project-select-empty h3,\n.project-select-empty p {\n  color: var(--text-secondary) !important;\n}\n\n.workspace-modal.project-select-modal .project-select-subtitle {\n  color: rgba(255, 255, 255, 0.85) !important;\n}\n\n/* Projects status tabs — app uses data-theme, not .dark-mode */\n[data-theme=\"dark\"] .status-tabs {\n  background-color: var(--surface) !important;\n  border-color: var(--border) !important;\n}\n\n[data-theme=\"dark\"] .status-tab {\n  background-color: transparent !important;\n  color: var(--text-secondary) !important;\n  border: 1px solid transparent !important;\n}\n\n[data-theme=\"dark\"] .status-tab:hover {\n  background-color: var(--surface-hover) !important;\n  color: var(--text-primary) !important;\n}\n\n[data-theme=\"dark\"] .status-tab.active {\n  background-color: color-mix(in srgb, var(--primary, #3b82f6) 18%, var(--surface)) !important;\n  color: var(--text-primary) !important;\n  border-color: var(--primary, #3b82f6) !important;\n  box-shadow: none !important;\n}\n\n[data-theme=\"dark\"] .status-tab.active .tab-count {\n  background-color: color-mix(in srgb, var(--primary, #3b82f6) 30%, transparent) !important;\n}\n\n[data-theme=\"dark\"] .projects-container,\n[data-theme=\"dark\"] .projects-table-container,\n[data-theme=\"dark\"] .projects-table {\n  background: var(--bg-primary) !important;\n  color: var(--text-primary) !important;\n  border-color: var(--border) !important;\n}\n\n[data-theme=\"dark\"] .projects-table th {\n  background: var(--table-header, var(--bg-tertiary)) !important;\n  color: var(--text-secondary) !important;\n  border-color: var(--border) !important;\n}\n\n[data-theme=\"dark\"] .projects-table td {\n  border-color: var(--border) !important;\n  color: var(--text-primary) !important;\n}\n\n/* Projects workspace embed */\n.rt-projects-embed .projects-container {\n  padding: 0 !important;\n  background: transparent !important;\n  box-shadow: none !important;\n}\n\n.rt-projects-search {\n  width: 100%;\n  max-width: 28rem;\n  padding: 0.55rem 2.25rem 0.55rem 2.4rem;\n  border: 1px solid var(--border);\n  border-radius: 8px;\n  background: var(--input-background, var(--surface));\n  color: var(--text-primary);\n  font: inherit;\n}\n\n.rt-projects-search:focus {\n  outline: none;\n  border-color: var(--primary, #2563eb);\n  box-shadow: 0 0 0 3px color-mix(in srgb, var(--primary, #2563eb) 20%, transparent);\n}\n\n.rt-projects-embedded .projects-header {\n  margin-bottom: 12px;\n  align-items: flex-end;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
